import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TimeAndLocation"] */ "/app/src/app/events/[id]/TimeAndLocation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventMapMarker"] */ "/app/src/app/events/EventMapMarker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventViewAnalyticsLogger"] */ "/app/src/features/analytics/EventViewAnalyticsLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCalendar"] */ "/app/src/features/components/AddToCalendar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/components/Categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompositeHeroImage"] */ "/app/src/features/components/CompositeHeroImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/components/DateBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkButton"] */ "/app/src/features/components/LinkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Map"] */ "/app/src/features/components/Map.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useUiStrings"] */ "/app/src/features/store/uiStrings.ts");
